import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';
import { setSubmitting, setError } from '../Slice/unifiedFormSlice';

interface SubmitIdentityExtraInfoPayload {
  identity_type: string;
  national_id: string;
  address: string;
  postal_code: string;
  phone: string;
  publisher_id: string;
  national_id_image?: File | null;
  contract?: File | null;
}

export const submitIdentityExtraInfo = createAsyncThunk(
  'unifiedForm/submitIdentityExtraInfo',
  async (payload: SubmitIdentityExtraInfoPayload, { dispatch }) => {
    console.log('Submitting payload:', payload); // دیباگ
    if (!payload.postal_code) {
      console.warn('postal_code is empty in payload');
    }
    dispatch(setSubmitting(true));
    try {
      const formData = new FormData();
      if (payload.national_id_image) {
        formData.append('national_id_image', payload.national_id_image);
      } else {
        console.warn('No national_id_image provided');
      }
      if (payload.contract) {
        formData.append('contract', payload.contract);
      }

      const response = await apiClient.post(
        'v2/publisher/createExtraInformation',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json',
          },
          params: {
            identity_type: payload.identity_type,
            national_id: payload.national_id,
            address: payload.address,
            postal_code: payload.postal_code,
            phone: payload.phone,
            publisher_id: payload.publisher_id,
          },
        },
      );

      console.log('API response:', response.data);
      return response.data;
    } catch (error: any) {
      // The api client interceptor already unwrapped the response body, so
      // the server's own message lives on `error.message`.
      console.error('API error:', error);
      dispatch(setError(error?.message || 'خطا در ارسال اطلاعات'));
      throw error;
    } finally {
      dispatch(setSubmitting(false));
    }
  },
);